module.exports = __webpack_public_path__ + "media/images/add-device-icon-3fc8e1ab8a3e2177590f3550828c22c2.svg";